import { axios } from '@/axios';
// import { eventBus } from '@/event-bus';
import routes from '@/web-api/routes';
import storeHelper from '@/vuex/helper';
// import storageManager from '@/storage-manager';

export default {
  updateReadStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.put(routes.webapi.user.notification.update, payload)
        .then((response) => {
          commit('savedItems/setItemData', response.data.data, { root: true });
          return resolve(response.data.data);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error);
        });
    });
  },
};
